<div class="flex flex-col">
  <ng-container *ngIf="sanitizedCommittees.length > 0; else noInternationalMirrorCommittee">
    <div *ngFor="let committee of sanitizedCommittees; let i = index">

      <div class="flex flex-col lg:flex-row mt-4" [attr.id]="'committee-' + i + '-membership-status'">
        <div class="lg:w-1/3">
          <p class="font-bold">Membership Status</p>
        </div>
        <div class="lg:w-2/3">
          <div [innerHTML]="committee.membershipStatus"></div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row mt-4" [attr.id]="'committee-' + i + '-australian-participation'">
        <div class="lg:w-1/3">
          <p class="font-bold">Need for Australian Participation</p>
        </div>
        <div class="lg:w-2/3">
          <div [innerHTML]="committee.needForAustralianParticipation"></div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row mt-4" [attr.id]="'committee-' + i + '-national-policy-alignment'">
        <div class="lg:w-1/3">
          <p class="font-bold">Alignment with national public policy</p>
        </div>
        <div class="lg:w-2/3">
          <div [innerHTML]="committee.alignmentWithNationalPublicPolicy"></div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row mt-4" [attr.id]="'committee-' + i + '-net-benefit'">
        <div class="lg:w-1/3">
          <p class="font-bold">Net Benefit</p>
        </div>
        <div class="lg:w-2/3">
          <div [innerHTML]="committee.netBenefit"></div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row mt-4" [attr.id]="'committee-' + i + '-harmonisation-alignment'">
        <div class="lg:w-1/3">
          <p class="font-bold">Harmonisation and alignment</p>
        </div>
        <div class="lg:w-2/3">
          <div [innerHTML]="committee.harmonisationAndAlignment"></div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row mt-4" [attr.id]="'committee-' + i + '-comments'">
        <div class="lg:w-1/3">
          <p class="font-bold">Comments</p>
        </div>
        <div class="lg:w-2/3">
          <div [innerHTML]="committee.comments"></div>
        </div>
      </div>

      <div class="flex flex-col lg:flex-row mt-4" [attr.id]="'committee-' + i + '-expiry-date'">
        <div class="lg:w-1/3">
          <p class="font-bold">Case expiry date</p>
        </div>
        <div class="lg:w-2/3">
          <div [innerHTML]="committee.caseExpiryDate"></div>
        </div>
      </div>

      <hr class="my-6 border-t" *ngIf="i < sanitizedCommittees.length - 1" />
    </div>
  </ng-container>

  <ng-template #noInternationalMirrorCommittee>
    <div class="text-center py-6" id="no-record-found">No records found</div>
  </ng-template>

</div>
<div *ngIf="sanitizedCommittees.length > 0" class="flex justify-end pt-4">
  <app-back-to-top id="btn-back-to-top"></app-back-to-top>
</div>
